import {Component, inject, OnInit} from '@angular/core';
import {NgWizardConfig, NgWizardModule, NgWizardService, STEP_STATE, StepChangedArgs, THEME} from "ng-wizard";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {ArbitraryType, SrmHospitalArbitrary} from "../../../../../generated-model/model";
import {ActivatedRoute, Router} from "@angular/router";
import {NgIf} from "@angular/common";
import {GtNgDatepickerModule} from "../../../../shared/commons/gt-ng-datepicker/gt-ng-datepicker.module";
import {FormsModule} from "@angular/forms";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {SrmHospitalArbitraryResource} from "../../../../service/SrmHospitalArbitraryResource";
import {ConfirmDialogService} from "../../../../shared/commons/dialog/confirm-dialog/confirm-dialog.service";
import {filter} from "rxjs/operators";
import {ToastService} from "../../../../shared/commons/toast/toast-service";

@Component({
  selector: 'app-tasks-details',
  standalone: true,
  imports: [
    NgWizardModule,
    NgIf,
    GtNgDatepickerModule,
    FormsModule,
    SharedCommonModule
  ],
  templateUrl: './tasks-details.component.html',
  styleUrl: './tasks-details.component.scss'
})
export class TasksDetailsComponent implements OnInit {

  currentDate: NgbDateStruct = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  }
  srmHospitalArbitrary: SrmHospitalArbitrary;
  stepStates = {
    normal: STEP_STATE.normal,
  };

  config: NgWizardConfig = {
    theme: THEME.arrows,
    keyNavigation: false,
    cycleSteps: false,
    anchorSettings: {
      anchorClickable: false
    },
    toolbarSettings: {
      showNextButton: false,
      showPreviousButton: false,
    }
  };

  _activatedRoute = inject(ActivatedRoute)
  _ngWizardService = inject(NgWizardService)
  _router = inject(Router)
  srmHospitalArbitraryResource = inject(SrmHospitalArbitraryResource)
  confirmDialogService = inject(ConfirmDialogService)
  private _toastrService: ToastService = inject(ToastService);

  constructor() {
    this._activatedRoute.data.subscribe((data: any) => {
      this.srmHospitalArbitrary = data.srmHospitalArbitrary;
    });
  }

  ngOnInit() {

    if (this.srmHospitalArbitrary.arbitraryStatus === 'NHSO_DISTRICT_REPORTS') {
      this.config.selected = 0
    } else if (this.srmHospitalArbitrary.arbitraryStatus === 'TEAM_EXAMINED_REPORT') {
      this.config.selected = 1
    } else if (this.srmHospitalArbitrary.arbitraryStatus === 'INSPECTION_OF_REGISTRY_OFFICE') {
      this.config.selected = 2
    } else if (this.srmHospitalArbitrary.arbitraryStatus === 'SUMMARIZE_RESULTS') {
      this.config.selected = 3
    } else {
      this.config.selected = 0
    }
  }

  stepChanged(args: StepChangedArgs) {
    console.log(args.step);
  }

  ARBITRARY_TYPE(value: string) {

    return ArbitraryType[value]
  }

  saveStep1() {
    const modalRef = this.confirmDialogService.open({
      content: 'ยืนยันการบันทึก'
    })
      .pipe(filter(e => !!e))
      .subscribe(e => {
        this.srmHospitalArbitraryResource.saveTaskDetailsStep1(this.srmHospitalArbitrary.id)
          .subscribe(value => {
            this._toastrService.showSuccess("บันทึกเสร็จสมบูรณ์");
            this.reset();
          });
      });
  }

  reset() {
    this._router.navigate(['/secure/arbitrary/new'])
  }

  saveStep2() {

    const modalRef = this.confirmDialogService.open({
      content: 'ยืนยันการบันทึก'
    })
      .pipe(filter(e => !!e))
      .subscribe(e => {
        this.srmHospitalArbitraryResource.saveTaskDetailsStep2({
          srmHospitalArbitraryId: this.srmHospitalArbitrary.id,
          auditCheckDate: this.srmHospitalArbitrary.auditCheckDate
        })
          .subscribe(value => {
            this._toastrService.showSuccess("บันทึกเสร็จสมบูรณ์");
            this.reset();
          });
      });
  }
}
